import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ItemList from 'flarum/common/utils/ItemList';
import SubscriptionCard from './SubscriptionCard';
import type Mithril from 'mithril';
import type { IPageAttrs } from 'flarum/common/components/Page';
import type User from 'flarum/common/models/User';
import type Subscription from '../../common/Subscription';

/**
 * The `DiscussionsUserPage` component shows a discussion list inside of a user
 * page.
 */
export default class UserSubscriptionsPage extends UserPage {
  private loading = false;
  private subscriptions: Subscription[] = [];

  oninit(vnode: Mithril.Vnode<IPageAttrs, this>) {
    super.oninit(vnode);

    this.loading = true;

    this.loadUser(m.route.param('username'));

    this.loadSubscriptions();
  }

  show(user: User) {
    super.show(user);
  }

  content() {
    return <div className="AccessPortal SubscriptionsUserPage">{this.loading ? <LoadingIndicator /> : this.items().toArray()}</div>;
  }

  items() {
    const items = new ItemList<Mithril.Children>();

    this.subscriptions.forEach((subscription) => {
      items.add(subscription.id(), <SubscriptionCard subscription={subscription} />);
    });

    if (!this.loading && this.subscriptions.length === 0) {
      items.add('empty', <SubscriptionCard subscription={null} />);
    }

    return items;
  }

  loadSubscriptions(): void {
    app.store.find<Subscription[]>('blomstra-payments/stripe/user-subscriptions').then((subscriptions) => {
      this.subscriptions = subscriptions;

      this.loading = false;

      m.redraw();
    });
  }
}
